import crc32mpeg2 from './calculators/crc32mpeg2.js';
import defineCrc from './define_crc.js';
export default defineCrc('crc-32-mpeg', crc32mpeg2);
